import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const setInActiveUserContext = React.createContext({});
export let setInActiveUserMachine: any;

const MODULE_NAME = 'machines.setInActiveUser';

export const useSMSetInActiveUser = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  setInActiveUserMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(setInActiveUserMachine);

  return {
    setInActiveUserMachine,
    setInActiveUserState: state,
    setInActiveUserSend: send,
  };
};
